import api from "@/libs/axios";
import * as ep from "./endpoints";

export default {
  namespaced: true,
  state: () => ({
    founders: [],
    loading: false,
    pagination:{}
  }),
  getters: {
    founders(state) {
      return state.founders;
    },
    loading(state) {
      return state.loading;
    },
    pagination(state){
      return state.pagination
    }
  },
  mutations: {
    setFounders(state, payload) {
      state.founders = payload;
    },
  },
  actions: {
    async getFounders(context, payload) {
      context.state.loading = true;
      await api
        .get(ep.FOUNDERS(payload.type), { params: { page: payload.page } })
        .then((res) => {
          context.commit("setFounders", res.data.data);
          context.state.pagination = res.data.pagination;
          context.state.loading = false;
        });
    },

  },
};
